import { ACCOUNT_ORDERS_URL, FEATURE_SHOW_MIAW_CHAT } from '../../../consts/env'


const RETURN_URL_PATHNAME = '/customer-services/returns'
const DECISION_TREE_QUERY_PARAM = "dt"
const CONTACT_US_PATHNAME = "/customer-services/contact-us"

export const getIsInCustomerServicePage = () => {
  const isInCustomerServicePage = window.location.href.includes('customer-services')
  const isInOrdersAndTrackURL = window.location.href.includes(ACCOUNT_ORDERS_URL)
  const isInOrdersAndTrackUIPage = window?.jlData?.page?.pageInfo?.breadCrumb?.some(
    (breadcrumb: { value: string; clickable?: number }) =>
      breadcrumb?.value === 'online orders' || breadcrumb?.value === 'track your order'
  )
  return isInCustomerServicePage || isInOrdersAndTrackUIPage || isInOrdersAndTrackURL
}

const getUrlWithSearchParams = () => {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);
  return {
    url,
    searchParams
  }
}

export const getIsAgentForceServicablePage = () => {
  const { url, searchParams } = getUrlWithSearchParams()
  return url.pathname === RETURN_URL_PATHNAME && (searchParams.get(DECISION_TREE_QUERY_PARAM) === null || searchParams.get(DECISION_TREE_QUERY_PARAM) === "")
}

export const getIsDefaultMIAWServicablePage = () => {
  const { url, searchParams } = getUrlWithSearchParams()
  const dt = searchParams.get(DECISION_TREE_QUERY_PARAM) as string;

  if (url.pathname === RETURN_URL_PATHNAME) {
    const validReturnPrefix = 'returningAnItem-small-faulty-no';
    const validReturnItems = [
      'returningAnItem-large-faultyLarge',
      'returningAnItem-small-faulty-yes',
      validReturnPrefix,
    ];

    if (validReturnItems.includes(dt) || dt?.startsWith(validReturnPrefix)) {
      return true;
    }
  }

  if (url.pathname === CONTACT_US_PATHNAME) {
    const validContactUsItems = ["problemsWithProduct-electrical-thirtyDaysOrLess", "problemsWithProduct-electrical-overThirtyDays"];
    if (validContactUsItems.includes(dt)) {
      return true;
    }
  }

  return false;
}

export const getPageStatus = () => {
  return {
    isInCustomerServicePage: getIsInCustomerServicePage(),
    isAgentForceServicablePage: getIsAgentForceServicablePage(),
    isDefaultMIAWServicablePage: FEATURE_SHOW_MIAW_CHAT ? !getIsAgentForceServicablePage() : getIsDefaultMIAWServicablePage(),
  };
};
